import { AppBar } from "@features/dashboard/layouts/AppBar";
import { handleNavigateBack } from "@helpers/common";
import { useDevice } from "@memorang/ui/useDevice";
import { TopTabs } from "expo-router/js-top-tabs";

export default function LegalLayout() {
	const { isMobile } = useDevice();
	return (
		<>
			<AppBar
				variant="public"
				onPressBack={() => handleNavigateBack("/")}
				showLogo={!isMobile}
				title="Read our rules & policies"
			/>
			<TopTabs>
				<TopTabs.Screen name="privacy" options={{ title: "Privacy Policy" }} />
				<TopTabs.Screen name="terms" options={{ title: "Terms of Service" }} />
			</TopTabs>
		</>
	);
}
